import { Tabs } from 'antd';
import styled from 'styled-components';
import { theme } from 'styles';
import { Flex } from 'UI/Flex';
import { TabsVariant } from 'UI/Tabs/Tabs';

export const STab = styled(Flex)<{
  active: boolean;
  disabled: boolean;
  variant: TabsVariant;
}>`
  align-items: center;
  justify-content: center;

  ${({ variant, active }) => {
    switch (variant) {
      case 'white':
        return `
          background-color: ${active ? theme.color.white : theme.color.grey95_light};
          height: 36px;
          margin: 0 1px;
          border-radius: 3px 3px 0 0;
          border: solid 1px ${theme.color.grey95_light};
          border-bottom: none;
        `;
      case 'whiteActiveBlue':
        return `
          background-color: ${active ? theme.color.clear_blue : theme.color.grey95_light};
          height: 36px;
          margin: 0 1px;
          border-radius: 3px 3px 0 0;
          border: solid 1px ${theme.color.grey95_light};
          border-bottom: none;
        `;
      case 'greyBlue':
        return `
          background-color: ${active ? theme.color.clear_blue : theme.color.grey90};
          height: 57px;
          flex: 0 1 auto;
          padding: 20px;
          border-radius: 9px;
          border: solid 1px ${theme.color.grey90};
          border-bottom: none;
        `;
      case 'blueActiveWhite':
        return `
          background-color: ${active ? theme.color.white : 'none'};
          height: 36px;
          flex: 0 1 auto;
          border-bottom: ${active ? `solid 2px ${theme.color.clear_blue}` : 'none'};
          margin-bottom: -1px;
        `;
      case 'greyActiveBlack':
        return `
          background-color: ${active ? theme.color.brand_black : theme.color.grey90};
          height: 36px;
          padding: 0 20px 0 20px;
          flex: 0 1 auto;
          border-radius: 18px;
        `;
      default:
        return '';
    }
  }};

  :hover {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  }
`;

export const GreyBlueWrapper = styled.div`
  height: 72px;
  padding: 7px;
  background-color: ${theme.color.grey90};
  border-radius: 12px;
`;

export const BlueActiveWhiteWrapper = styled.div`
  border-bottom: solid 1px ${theme.color.grey90};
`;

export const SViewTabs = styled(Tabs)<{ $margin?: string }>`
  width: 100%;
  overflow: visible;

  &.ant-tabs-top > .ant-tabs-nav,
  &.ant-tabs-bottom > .ant-tabs-nav,
  &.ant-tabs-top > div > .ant-tabs-nav,
  &.ant-tabs-bottom > div > .ant-tabs-nav {
    ${({ $margin }) => $margin && `margin: ${$margin};`}
  }

  .ant-tabs-nav-list {
    width: auto;
  }

  .ant-tabs-nav-wrap {
    justify-content: flex-end;

    .ant-tabs-tab {
      border-radius: 4px !important;

      &:hover:not(.ant-tabs-tab-active) {
        background-color: ${({ theme }) => theme.color.grey95};

        .ant-tabs-tab-btn {
          color: ${({ theme }) => theme.color.brand_black};
        }
      }
    }

    .ant-tabs-tab-active {
      background-color: ${({ theme }) => theme.color.brand_black};

      .ant-tabs-tab-btn {
        color: white;
      }
    }
  }
`;
